import {
  invoiceStartGuideSteps,
  invoiceStartGuideTexts,
} from "EinvoiceProject/InvoiceStartGuide/invoiceStartGuideContent";

export const invoiceStartGuideContent = {
  texts: invoiceStartGuideTexts,
  steps: invoiceStartGuideSteps,
};
